import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import { NeedReviewView } from "@/components/aicheck/NeedReviewView";
import type { AICheckRunResult } from "@/types/aicheck";

interface NeedReviewTabProps {
  result: AICheckRunResult;
  activeTab: ActiveTab;
  onReturnToSummary: (findingIndex: number) => void;
  onProjectDataReferenceClick: (source: string) => void;
}

/** 「Need Review」タブ本体。tabpanel ラッパ + NeedReviewView。 */
export function NeedReviewTab({
  result,
  activeTab,
  onReturnToSummary,
  onProjectDataReferenceClick,
}: NeedReviewTabProps) {
  return (
    <div
      id="results-panel-review"
      role="tabpanel"
      aria-labelledby="results-tab-review"
      hidden={activeTab !== "review"}
    >
      <NeedReviewView
        result={result}
        onReturnToSummary={onReturnToSummary}
        onProjectDataReferenceClick={onProjectDataReferenceClick}
      />
    </div>
  );
}
